module.exports = __webpack_public_path__ + "static/media/back.2acc37b8.svg";